export const API_PATH_ApiAppPresetArchive = '/services/app/presets/apiAppPresetArchive';
